import { useState } from 'react';
import { ViewerModal } from './elements/viewerModal/ViewerModal';

type ExportPdfPreviewProps = {
    filename: string;
    url: string;
};

export function ExportPdfThumbnail(props: ExportPdfPreviewProps) {
    const { filename, url } = props;

    const [showUrl, setShowUrl] = useState<string | null>(null);

    return (
        <>
            <div className={`layout horizontal-wrap asset-thumbnails`}>
                <div>
                    <div className="thumbnail">
                        <button
                            className="thumbnail__link"
                            onClick={() => {
                                setShowUrl(url);
                            }}
                            style={{ background: 'transparent', border: 'none' }}
                        >
                            <img
                                alt={filename}
                                className="thumbnail__img"
                                src={'/assets/svg/icon-pdf.svg'}
                            />
                        </button>
                    </div>
                    <span>{filename}</span>
                </div>
            </div>

            {showUrl && (
                <ViewerModal
                    assets={[
                        {
                            filename: url,
                            id: '1',
                            isGeneratedPdf: true,
                        },
                    ]}
                    hideThumbnail={true}
                    isPdf={true}
                    onClose={() => setShowUrl(null)}
                    selectedFileId="1"
                    url={url}
                />
            )}
        </>
    );
}
